/**
 * @param {String} type
 * @param {Object} draft
 * @param {String} input
 */
export default function create(type, draft, input) {
  draft[type].list.push(input);
  draft[type].map.set(input.uuid, input);
}
